// extracted by mini-css-extract-plugin
export default {"container":"Interest_container__NZlPG"};